var jQuery = require('jquery');
require('jquery-ui');

jQuery(document).ready(function($) {

  $( ".accordion" ).accordion({
    collapsible: true,
    heightStyle: "content"
  });

});



//////////////////
// WEBPACK FOOTER
// ./views/js/faq.js
// module id = 15
// module chunks = 5